import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import Container from 'components/Container';

const stylingPropTypes = {
  bg: PropTypes.string,
  variant: PropTypes.string
};

const Fallback = ({ bg, variant }) => {
  return <Container bg={bg} variant={variant} isLoading />;
};

Fallback.propTypes = {
  ...stylingPropTypes
};

const RoutingSuspense = ({ children, bg, variant }) => {
  return (
    <Suspense fallback={<Fallback bg={bg} variant={variant} />}>{children}</Suspense>
  );
};

RoutingSuspense.propTypes = {
  ...stylingPropTypes,
  children: PropTypes.node
};

export default RoutingSuspense;
